import { PROTOCOL } from "@/base/base.constants";

export const MONOLITH_HOST = process?.env?.[
  "NEXT_PUBLIC_MONOLITH_HOST"
] as string;

export const MONOLITH_ORIGIN = `${PROTOCOL}://${MONOLITH_HOST}`;
